import getOnColor from "../getOnColor";
import throwError from "../throwError";

/**
 *
 * @param theme - Theme object
 * @param onColor - Color of background on which is located styling element
 * @returns checked dark background
 */
var isDarkOnColor = function isDarkOnColor(theme, onColor) {
  var onColorValues = getOnColor(theme, onColor);
  if (!onColorValues) {
    return throwError("Passed color doesn't have defined onColor!");
  }
  return onColorValues.color === "#fff";
};
export default isDarkOnColor;